/**
 * Shared pool-domain copy. The over-subscribed message is shown in two places — the analytics pool
 * composition donut (its over-capacity help/tooltip) and the Show-Dashboard pool tile's over-capacity
 * tooltip — so it lives here once. An over-subscribed pool (Σ member issued > total_amount) is a legacy
 * state: tickets were issued before the pool existed, so it reads above its shared capacity. See
 * docs/pools_business_logic.md §2 (Lifetime-Σ) and §4 (flow tightening that prevents new occurrences).
 */
export const POOL_OVERSUBSCRIBED_MESSAGE =
	'More tickets are out than the pool holds — some were issued before the pool was created, so it reads over capacity.';
